import React from "react";
import { Box } from "@mui/material";

/**
 * 未読バッジ
 */
export default function UnreadBadge({ show = false }) {
  if (!show) return null;

  return (
    <Box
      aria-label="未読のお知らせがあります"
      sx={{
        minWidth: 16,
        height: 16,
        px: 0.5,
        borderRadius: "9999px",
        bgcolor: "error.main",
        color: "#fff",
        fontSize: 10,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
        mr: 1,
      }}
    >
      !
    </Box>
  );
}
